import dayjs from 'dayjs'

export const getTodayInMs = (): number => {
  const date = dayjs()
  // const timeOffset = (date.utcOffset() || 0) * 60 * 1000
  const dateInUTC = date.valueOf()
  return dateInUTC
}
